import { formatNumber, type HookFormMethods, HookFormResolver } from '@dec/shared';
import { Number, Text } from '@dec/shared';
import { Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import env from '@/env';

import { type TaxReturn } from '../../Reports/TaxReturnList/types';

export const TaxReturnPaymentSummary = ({
  taxReturn,
  paymentNumber,
  state
}: {
  taxReturn: TaxReturn;
  paymentNumber?: string;
  state?: string;
}) => {
  const { t } = useTranslation();
  const currencyCode = taxReturn.taxpayer?.recordData?.tax?.taxReturnCurrency?.code;
  const goToTaxReturn = () => {
    // const url = `${window.location.origin}/reports/taxreturn/${taxReturn.id}/general`;
    // window.open(url, '_blank', 'noopener,noreferrer');

    const url = `${env.appUrl}/reports/taxreturn/preview/${taxReturn.id}`;

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const labelForm = t('taxpayer-taxreturns.label.formId');
  const labelTaxReturnTotal = t('taxpayer-payments.label.amountTaxReturn');
  const labelPaymentNumber = t('taxpayer-payments.label.payment-number');
  const labelPeriod = t('taxpayer-taxreturns.label.period');
  const labelTaxReturnNumber = t('config.tinLegend');
  const labelState = t('taxpayer-taxreturns.header.taxreturnState');
  const size = paymentNumber ? 3 : 6;

  return (
    <HookFormResolver
      initialValues={{
        paymentNumber: paymentNumber,
        form: taxReturn.formVersion?.form?.name,
        taxReturnTotal: formatNumber(taxReturn.taxReturnTotal),
        taxReturnNumber: taxReturn.taxReturnNumber,
        state: t(`common.taxreturn-status.${state}`),
        period: taxReturn.period,
        currencyCode: currencyCode
      }}
      nameForm="HeaderForm"
      onSubmit={() => undefined}
    >
      {({ register }: HookFormMethods) => {
        return (
          <>
            <Row>
              {paymentNumber && (
                <Col xl={size} lg={size} md={size}>
                  <Text readonly={true} name="paymentNumber" label={labelPaymentNumber} />
                </Col>
              )}
              <Col xl={size} lg={size} md={size}>
                <Text readonly={true} name="form" label={labelForm} />
              </Col>

              <Col>
                <Text readonly={true} name="period" label={labelPeriod} />
              </Col>
              {state && (
                <Col>
                  <Text readonly={true} name="state" label={labelState} />
                </Col>
              )}
            </Row>
            <Row>
              <Col xl={6} lg={6} md={6}>
                <Form.Group>
                  {/*<Text readonly={true} name="taxReturnNumber" label={labelTaxReturnNumber} />*/}
                  <Form.Label>{labelTaxReturnNumber}</Form.Label>
                  <InputGroup className="mb-3">
                    <FormControl readOnly={true} {...register('taxReturnNumber')} />
                    {/* <Button onClick={goToTaxReturn} icon={} text="" variant="primary" /> */}
                  </InputGroup>
                </Form.Group>
              </Col>
              {/*<Col>*/}
              {/*  <Text readonly={true} name="currencyCode" label={labelCurrency} />*/}
              {/*</Col>*/}
              <Col>
                <Number
                  readonly={true}
                  allowDecimal={true}
                  prefix={currencyCode ? `${currencyCode} ` : undefined}
                  includeThousandsSeparator={true}
                  name="taxReturnTotal"
                  label={labelTaxReturnTotal}
                />{' '}
              </Col>
            </Row>
          </>
        );
      }}
    </HookFormResolver>
  );
};
